(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findById = exports.createForm = exports["default"] = void 0;

var _geoLocationService = require("impv/src/js/services/geo-location-service");

var _translateService = require("impv/src/js/services/translate-service");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isoCountries = {
  af: 'afghanistan',
  ax: 'aland islands',
  al: 'albania',
  dz: 'algeria',
  as: 'american samoa',
  ad: 'andorra',
  ao: 'angola',
  ai: 'anguilla',
  aq: 'antarctica',
  ag: 'antigua and barbuda',
  ar: 'argentina',
  am: 'armenia',
  aw: 'aruba',
  asc: 'ascension island',
  au: 'australia',
  at: 'austria',
  az: 'azerbaijan',
  bs: 'bahamas',
  bh: 'bahrain',
  bd: 'bangladesh',
  bb: 'barbados',
  by: 'belarus',
  be: 'belgium',
  bz: 'belize',
  bj: 'benin',
  bm: 'bermuda',
  bt: 'bhutan',
  bo: 'bolivia',
  bq: 'bonaire',
  ba: 'bosnia and herzegovina',
  bw: 'botswana',
  bv: 'bouvet island',
  br: 'brazil',
  io: 'british indian ocean territory',
  bn: 'brunei darussalam',
  bg: 'bulgaria',
  bf: 'burkina faso',
  bi: 'burundi',
  kh: 'cambodia',
  cm: 'cameroon',
  ca: 'canada',
  cv: 'cape verde',
  ky: 'cayman islands',
  cf: 'central african republic',
  td: 'chad',
  cl: 'chile',
  cn: 'china',
  cx: 'christmas island',
  cc: 'cocos (keeling) islands',
  co: 'colombia',
  km: 'comoros',
  cg: 'congo',
  cd: 'congo, dem. rep. of the',
  ck: 'cook islands',
  cr: 'costa rica',
  ci: 'ivory coast',
  hr: 'croatia',
  cu: 'cuba',
  cuw: 'curacao',
  cy: 'cyprus',
  cz: 'czech republic',
  dk: 'denmark',
  dj: 'djibouti',
  dm: 'dominica',
  "do": 'dominican republic',
  ec: 'ecuador',
  eg: 'egypt',
  sv: 'el salvador',
  gq: 'equatorial guinea',
  er: 'eritrea',
  ee: 'estonia',
  et: 'ethiopia',
  fk: 'falkland islands (malvinas)',
  fo: 'faroe islands',
  fj: 'fiji',
  fi: 'finland',
  fr: 'france',
  gf: 'french guiana',
  pf: 'french polynesia',
  tf: 'french southern territories',
  ga: 'gabon',
  gm: 'gambia',
  ge: 'georgia',
  de: 'germany',
  gh: 'ghana',
  gi: 'gibraltar',
  gr: 'greece',
  gl: 'greenland',
  gd: 'grenada',
  gp: 'guadeloupe',
  gu: 'guam',
  gt: 'guatemala',
  gg: 'guernsey',
  gn: 'guinea',
  gw: 'guinea-bissau',
  gy: 'guyana',
  ht: 'haiti',
  hm: 'heard island & mcdonald islands',
  va: 'holy see (vatican city state)',
  hn: 'honduras',
  hk: 'hong kong',
  hu: 'hungary',
  is: 'iceland',
  "in": 'india',
  id: 'indonesia',
  ir: 'iran, islamic republic of',
  iq: 'iraq',
  ie: 'ireland',
  im: 'isle of man',
  il: 'israel',
  it: 'italy',
  jm: 'jamaica',
  jp: 'japan',
  je: 'jersey',
  jo: 'jordan',
  kz: 'kazakhstan',
  ke: 'kenya',
  ki: 'kiribati',
  xk: 'kosovo',
  kw: 'kuwait',
  kg: 'kyrgyzstan',
  la: 'lao',
  lv: 'latvia',
  lb: 'lebanon',
  ls: 'lesotho',
  lr: 'liberia',
  ly: 'libyan arab jamahiriya',
  li: 'liechtenstein',
  lt: 'lithuania',
  lu: 'luxembourg',
  mo: 'macao',
  mk: 'macedonia',
  mg: 'madagascar',
  mw: 'malawi',
  my: 'malaysia',
  mv: 'maldives',
  ml: 'mali',
  mt: 'malta',
  mh: 'marshall islands',
  mq: 'martinique',
  mr: 'mauritania',
  mu: 'mauritius',
  yt: 'mayotte',
  mx: 'mexico',
  fm: 'micronesia, federated states of',
  md: 'moldova',
  mc: 'monaco',
  mn: 'mongolia',
  me: 'montenegro',
  ms: 'montserrat',
  ma: 'morocco',
  mz: 'mozambique',
  mm: 'myanmar',
  na: 'namibia',
  nr: 'nauru',
  np: 'nepal',
  nl: 'netherlands',
  an: 'netherlands antilles',
  nc: 'new caledonia',
  nz: 'new zealand',
  ni: 'nicaragua',
  ne: 'niger',
  ng: 'nigeria',
  nu: 'niue',
  nf: 'norfolk island',
  kr: 'north norea',
  mp: 'northern mariana islands',
  no: 'norway',
  om: 'oman',
  pk: 'pakistan',
  pw: 'palau',
  ps: 'palestinian territory',
  pa: 'panama',
  pg: 'papua new guinea',
  py: 'paraguay',
  pe: 'peru',
  ph: 'philippines',
  pn: 'pitcairn',
  pl: 'poland',
  pt: 'portugal',
  pr: 'puerto rico',
  qa: 'qatar',
  re: 'reunion',
  ro: 'romania',
  ru: 'russian federation',
  rw: 'rwanda',
  bl: 'saint barthelemy',
  sh: 'saint helena',
  kn: 'saint kitts and nevis',
  lc: 'saint lucia',
  mf: 'saint martin',
  pm: 'saint pierre and miquelon',
  vc: 'saint vincent and grenadines',
  ws: 'samoa',
  sm: 'san marino',
  st: 'sao tome and principe',
  sa: 'saudi arabia',
  sn: 'senegal',
  rs: 'serbia',
  sc: 'seychelles',
  sl: 'sierra leone',
  sg: 'singapore',
  sx: 'sint maartin (dutch part)',
  sk: 'slovakia',
  si: 'slovenia',
  sb: 'solomon islands',
  so: 'somalia',
  za: 'south africa',
  gs: 'south georgia and sandwich islands',
  kp: 'south korea',
  sd: 'sudan',
  es: 'spain',
  lk: 'sri lanka',
  sr: 'suriname',
  sj: 'svalbard and jan mayen',
  sz: 'swaziland',
  se: 'sweden',
  ch: 'switzerland',
  sy: 'syrian arab republic',
  tw: 'taiwan',
  tj: 'tajikistan',
  tz: 'tanzania',
  th: 'thailand',
  tl: 'timor-leste',
  tg: 'togo',
  tk: 'tokelau',
  to: 'tonga',
  tt: 'trinidad and tobago',
  tn: 'tunisia',
  tr: 'turkey',
  tm: 'turkmenistan',
  tc: 'turks and caicos islands',
  tv: 'tuvalu',
  ug: 'uganda',
  ua: 'ukraine',
  ae: 'united arab emirates',
  gb: 'united kingdom',
  us: 'united states',
  um: 'united states minor outlying islands',
  uy: 'uruguay',
  uz: 'uzbekistan',
  vu: 'vanuatu',
  ve: 'venezuela',
  vn: 'vietnam',
  vg: 'virgin islands, british',
  vi: 'virgin islands, u.s.',
  wf: 'wallis and futuna',
  eh: 'western sahara',
  ye: 'yemen',
  zm: 'zambia',
  zw: 'zimbabwe'
};
var emails = ['gamil.com', 'gmail.co', 'gmail.org', 'gmail.com', 'aol.com', 'att.net', 'comcast.net', 'facebook.com', 'gmx.com', 'googlemail.com', 'google.com', 'hotmail.com', 'hotmail.co.uk', 'mac.com', 'me.com', 'mail.com', 'msn.com', 'live.com', 'sbcglobal.net', 'verizon.net', 'yahoo.com', 'yahoo.co.uk', 'email.com', 'fastmail.fm', 'games.com ', 'gmx.net', 'hush.com', 'hushmail.com', 'icloud.com', 'iname.com', 'inbox.com', 'lavabit.com', 'love.com ', 'outlook.com', 'pobox.com', 'protonmail.ch', 'protonmail.com', 'tutanota.de', 'tutanota.com', 'tutamail.com', 'tuta.io', 'keemail.me', 'rocketmail.com ', 'safe-mail.net', 'wow.com ', 'ygm.com ', 'ymail.com ', 'zoho.com', 'yandex.com', 'bellsouth.net', 'charter.net', 'cox.net', 'earthlink.net', 'juno.com', 'btinternet.com', 'virginmedia.com', 'blueyonder.co.uk', 'freeserve.co.uk', 'live.co.uk', 'ntlworld.com', 'o2.co.uk', 'orange.net', 'sky.com', 'talktalk.co.uk', 'tiscali.co.uk', 'virgin.net', 'wanadoo.co.uk', 'bt.com', 'sina.com', 'sina.cn', 'qq.com', 'naver.com', 'hanmail.net', 'daum.net', 'nate.com', 'yahoo.co.jp', 'yahoo.co.kr', 'yahoo.co.id', 'yahoo.co.in', 'yahoo.com.sg', 'yahoo.com.ph', '163.com', 'yeah.net', '126.com', '21cn.com', 'aliyun.com', 'foxmail.com', 'hotmail.fr', 'live.fr', 'laposte.net', 'yahoo.fr', 'wanadoo.fr', 'orange.fr', 'gmx.fr', 'sfr.fr', 'neuf.fr', 'free.fr', 'gmx.de', 'hotmail.de', 'live.de', 'online.de', 't-online.de ', 'web.de', 'yahoo.de', 'libero.it', 'virgilio.it', 'hotmail.it', 'aol.it', 'tiscali.it', 'alice.it', 'live.it', 'yahoo.it', 'email.it', 'tin.it', 'poste.it', 'teletu.it', 'mail.ru', 'rambler.ru', 'yandex.ru', 'ya.ru', 'list.ru', 'hotmail.be', 'live.be', 'skynet.be', 'voo.be', 'tvcablenet.be', 'telenet.be', 'hotmail.com.ar', 'live.com.ar', 'yahoo.com.ar', 'fibertel.com.ar', 'speedy.com.ar', 'arnet.com.ar', 'yahoo.com.mx', 'live.com.mx', 'hotmail.es', 'hotmail.com.mx', 'prodigy.net.mx', 'yahoo.ca', 'hotmail.ca', 'bell.net', 'shaw.ca', 'sympatico.ca', 'rogers.com', 'yahoo.com.br', 'hotmail.com.br', 'outlook.com.br', 'uol.com.br', 'bol.com.br', 'terra.com.br', 'ig.com.br', 'itelefonica.com.br', 'r7.com', 'zipmail.com.br', 'globo.com', 'globomail.com', 'oi.com.br'];

var getCountryCodeFromName = function getCountryCodeFromName(countryName) {
  return Object.keys(isoCountries).find(function (key) {
    return isoCountries[key] === countryName;
  });
}; // TODO: move the setting to marketo config file


var MARKETO_SERVER_URL = '//go.imperva.com';
var MARKETO_APP_KEY = '727-WRL-406';
var marketoForms = global.marketoForms = global.marketoForms || {};
var siteUrl = location.protocol + '//' + location.host;

var MarketoForm =
/*#__PURE__*/
function () {
  function MarketoForm(formId) {
    var formArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var elem = arguments.length > 2 ? arguments[2] : undefined;
    var runNextFormFn = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, MarketoForm);

    this.uuid = formArgs.uuid || parseInt(Math.random() * 10000);
    this.uniqueIdPostfix = '_' + this.uuid;
    this.formId = formId;
    this.formArgs = formArgs;
    this.runNextFormFn = runNextFormFn;
    this.cbs = [];
    this.onSubmitCbs = [];
    this.onValidateCbs = [];
    this.pressOnEnterTimer = null;
    this.clickOnSubmitTimer = null;
    this.keyEnterPressed = false;
    this.submitBtnClicked = false;
    this.elem = elem;
    this.buttonText = this.getFormElem(this.form).find('.mktoButtonWrap button[type="submit"]').text();

    if (!this.elem) {
      console.error('MarketoForm:constructor missing elem param for form ID ', this.formId);
    }

    this.modifyElementsId();
    this.setupMarketoForm(formArgs);
    this.createForm();
    this.sendValidate();
    this.sendSubmit();
  }

  _createClass(MarketoForm, [{
    key: "createForm",
    value: function () {
      var _createForm = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.elem) {
                  $(this.elem).attr('id', "mktoForm_".concat(this.formId));
                }

                try {
                  if ('MktoForms2' in window) {
                    MktoForms2.loadForm(MARKETO_SERVER_URL, MARKETO_APP_KEY, this.formId, function (form) {
                      _this.form = form;
                      _this.formElem = _this.getFormElem(form);

                      _this.formElem.attr('id', '');

                      _this.formElem.addClass('mkto-loaded');

                      _this.isHtmlTemplate = $('.mktoTemplateBox', _this.formElem).length > 0;

                      if (_this.isHtmlTemplate) {
                        _this.setHtmlTemplate();
                      }

                      _this.fireEvent();

                      if (typeof _this.runNextFormFn === 'function') {
                        _this.runNextFormFn();
                      }

                      var formLoadedEvt = new CustomEvent('mktoFormLoaded', {
                        detail: _this.formElem.attr('data-form-id')
                      });

                      if ($(_this.formElem).length) {
                        $(_this.formElem)[0].dispatchEvent(formLoadedEvt);
                      }
                    }); // console.log(`register MktoForm id ${this.formId}`);
                  } else {
                    console.error('MktoForms2 is not define');
                  }
                } catch (error) {
                  console.error('Error in class MarketoForm', error);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createForm() {
        return _createForm.apply(this, arguments);
      }

      return createForm;
    }()
  }, {
    key: "snapShotValidation",
    value: function snapShotValidation() {
      var _this2 = this;

      this.onSuccess(function (form) {
        var dataToSend = {};
        var formElem = $(form.formElem);
        var FirstName = formElem.find("#FirstName".concat(_this2.uniqueIdPostfix)).val();
        var LastName = formElem.find("#LastName".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['name'] = (formElem.find("#fullNameTrendemon".concat(_this2.uniqueIdPostfix)).val() !== undefined ? formElem.find("#fullNameTrendemon".concat(_this2.uniqueIdPostfix)).val() : FirstName + '-' + LastName).split(' ').join('-');
        dataToSend['telephone'] = formElem.find("#Phone".concat(_this2.uniqueIdPostfix)).val() !== undefined ? formElem.find("#Phone".concat(_this2.uniqueIdPostfix)).val() : '';
        dataToSend['email'] = formElem.find("#Email".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['state'] = formElem.find("#State".concat(_this2.uniqueIdPostfix)).val() !== undefined ? '&state=' + formElem.find("#State".concat(_this2.uniqueIdPostfix)).val() : '';
        dataToSend['jobTitle'] = formElem.find("#Title".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['company'] = formElem.find("#Company".concat(_this2.uniqueIdPostfix)).val();
        var eULAConsent = formElem.find($("[name=\"eULAConsent\"]"));
        dataToSend['eULAConsent'] = eULAConsent.prop('checked');
        dataToSend['eULAConsent_copy'] = eULAConsent.next().html();
        var countryInput = formElem.find("#Country".concat(_this2.uniqueIdPostfix));
        var countryName;

        if (countryInput.length) {
          countryName = countryInput.val().toLowerCase() == "cote d'ivoire" ? 'ivory coast' : countryInput.val().toLowerCase() == 'south sudan' ? 'sudan' : countryInput.val().toLowerCase();
        }

        dataToSend['country'] = getCountryCodeFromName(countryName) !== undefined ? getCountryCodeFromName(countryName) : countryName;
        $.ajax({
          type: 'POST',
          url: siteUrl + '/wp-json/imperva_snapshot/v1/register/',
          data: dataToSend,
          async: false,
          dataType: 'json',
          success: function success(data) {
            var response = $.parseJSON(data);

            if (response[0].includes('200')) {
              window.location.assign('/resources/snapshot-thank-you/');
            } else {
              window.location.assign('/resources/snapshot-problem/');
            }
          },
          error: function error() {
            window.location.assign('/resources/snapshot-problem/');
          }
        });
        return false;
      });
    }
  }, {
    key: "modifyElementsId",
    value: function modifyElementsId() {
      var _this3 = this;

      this.onLoad(function (form) {
        var formElem = _this3.getFormElem(form);

        if (formElem.length) {
          var fields = formElem.find('input, select, textarea');
          var labels = formElem.find('label');
          fields.each(function (i, el) {
            var $el = $(el);
            var id = $el.attr('id');

            if (id) {
              $el.attr('id', id + _this3.uniqueIdPostfix);
            }
          });
          labels.each(function (i, el) {
            var $el = $(el);
            var labelFor = $el.attr('for');

            if (labelFor) {
              $el.attr('for', labelFor + _this3.uniqueIdPostfix);
            }
          });
        }
      });
    }
  }, {
    key: "eCustomsValidation",
    value: function eCustomsValidation() {
      var _this4 = this;

      var thankYouUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.onSubmit(function (_form) {
        var formElem = $(_form.formElem);
        var FirstName = formElem.find("#FirstName".concat(_this4.uniqueIdPostfix)).val();
        var LastName = formElem.find("#LastName".concat(_this4.uniqueIdPostfix)).val();

        if ($('#allow_spaces').val() != '1' && _this4.formId == '2143' && (FirstName.includes(' ') || FirstName.includes('test'))) {
          _form.setErrorMessage('FirstName', 'please enter a valid name');

          return false;
        }

        if ($('#allow_spaces').val() != '1' && _this4.formId == '2143' && (LastName.includes(' ') || LastName.includes('test'))) {
          _form.setErrorMessage('LastName', 'please enter a valid name');

          return false;
        }

        var fullName = (formElem.find("#fullNameTrendemon".concat(_this4.uniqueIdPostfix)).val() !== undefined ? formElem.find("#fullNameTrendemon".concat(_this4.uniqueIdPostfix)).val() : FirstName + '-' + LastName).split(' ').join('-');
        var Phone = formElem.find("#Phone".concat(_this4.uniqueIdPostfix)).val() !== undefined ? formElem.find("#Phone".concat(_this4.uniqueIdPostfix)).val().split('-').join('') : '';
        var Email = formElem.find("#Email".concat(_this4.uniqueIdPostfix)).val();
        var State = formElem.find("#State".concat(_this4.uniqueIdPostfix)).val() !== undefined ? '&state=' + formElem.find("#State".concat(_this4.uniqueIdPostfix)).val() : '';
        var Title = formElem.find("#Title".concat(_this4.uniqueIdPostfix)).val();
        var Company = formElem.find("#Company".concat(_this4.uniqueIdPostfix)).val().replace(' ', '%20');
        var countryInput = formElem.find("#Country".concat(_this4.uniqueIdPostfix));
        var countryName;

        if (countryInput.length) {
          countryName = countryInput.val().toLowerCase() == "cote d'ivoire" ? 'ivory coast' : countryInput.val().toLowerCase() == 'south sudan' ? 'sudan' : countryInput.val().toLowerCase();
        }

        var Country = getCountryCodeFromName(countryName) !== undefined ? getCountryCodeFromName(countryName) : countryName;
        var url = siteUrl + "/wp-json/ecustoms_screening/v1/formID/".concat(_this4.formId, "?email=").concat(Email, "&name=").concat(fullName, "&telephone=").concat(Phone, "&jobTitle=").concat(Title, "&country=").concat(Country).concat(State, "&company=").concat(Company);
        var approve = false;
        var locationAssign = false;
        $.ajax({
          url: url,
          async: false,
          dataType: 'json',
          success: function success(response) {
            if (response != null && response.approved) {
              approve = true;

              if (thankYouUrl != null) {
                locationAssign = thankYouUrl;
              }
            } else {
              if (response === null) {
                console.log('eCustoms not available');
              }

              locationAssign = '/resources/free-tools-thank-you/';
              approve = false;
            }
          }
        });
        _this4.location_assign = locationAssign;
        return approve;
      });
    }
  }, {
    key: "fireEvent",
    value: function fireEvent() {
      var _this5 = this;

      if (this.cbs) {
        this.cbs.forEach(function (cb) {
          return cb(_this5.form);
        });
      }
    }
  }, {
    key: "onLoad",
    value: function onLoad(cb) {
      if (typeof cb === 'function') {
        if (this.form) {
          cb(this.form);
        } else {
          if (!this.cbs) {
            this.cbs = [];
          }

          this.cbs.push(cb);
        }
      }

      return this;
    }
    /**
     * register for input/s events
     * @param {string} eventNames
     * the events name to register
     * cab be multy event etc. 'change, input'
     * @param {string|function} inputName
     * if inputName is string ==> register for specific input | Else: if inputName is function => register for all inputs
     * @param {?function} cb
     * the callback function for this events
     * @return {MarketoForm} to chaining functions
     */

  }, {
    key: "registerEvent",
    value: function registerEvent(eventNames, inputName, cb) {
      var _this6 = this;

      if (typeof inputName === 'function') {
        cb = inputName;
        this.onLoad(function (form) {
          var formElem = _this6.getFormElem(form);

          if (eventNames) {
            eventNames.split(' ').filter(function (e) {
              return !!e;
            }).forEach(function (eventName) {
              $(formElem).on(eventName, "input, textarea, select", cb);
            });
          }
        });
      } else if (inputName && typeof cb === 'function') {
        this.onLoad(function (form) {
          var formElem = _this6.getFormElem(form);

          if (eventNames) {
            eventNames.split(' ').filter(function (e) {
              return !!e;
            }).forEach(function (eventName) {
              // console.log(
              //   `register event ${eventName} to elem ${inputName}`,
              //   $(`input[name="${inputName}"], textarea[name="${inputName}"], select[name="${inputName}"]`, formElem).data('events')
              // );
              $(formElem).on(eventName, "input[name=\"".concat(inputName, "\"], textarea[name=\"").concat(inputName, "\"], select[name=\"").concat(inputName, "\"]"), cb);
            });
          }
        });
      }

      return this;
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(cb) {
      var _this7 = this;

      if (typeof cb === 'function') {
        this.onLoad(function (form) {
          return form.onSuccess(function (values, followUpUrl) {
            var form_block = document.querySelector('.form-block');
            var form_wrap = document.querySelector('.form-section .form-wrapper');

            if (form_wrap && form_wrap.classList.contains('form-block-class')) {
              form_block.classList.add('form-block-success');
            }

            return cb(_this7, values, followUpUrl);
          });
        });
      }

      return this;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(cb) {
      if (typeof cb === 'function') {
        this.onSubmitCbs.push(cb);
      }

      return this;
    }
  }, {
    key: "sendSubmit",
    value: function sendSubmit() {
      var _this8 = this;

      this.onLoad(function (form) {
        return form.onSubmit(function (nativeValid) {
          var originalText = _this8.getButtonText(form);

          _this8.changeButtonText('Please wait', form);

          _this8.setButtonDisabled(form);

          var approvalsSubmit = [];

          _this8.onSubmitCbs.forEach(function (cb) {
            approvalsSubmit.push(cb(_this8));
          });

          if (!approvalsSubmit.includes(false) && nativeValid) {
            form.submittable(true);

            if (_this8.location_assign) {
              window.location.assign(_this8.location_assign);
            }

            return true;
          }

          _this8.changeButtonText(originalText, form);

          _this8.setButtonEnable(form);

          form.submittable(false);

          if (_this8.location_assign) {
            window.location.assign(_this8.location_assign);
          }

          return false;
        });
      });
    }
  }, {
    key: "onValidate",
    value: function onValidate(cb) {
      if (typeof cb === 'function') {
        this.onValidateCbs.push(cb);
      }

      return this;
    }
  }, {
    key: "sendValidate",
    value: function sendValidate() {
      var _this9 = this;

      this.onLoad(function (form) {
        return form.onValidate(function (nativeValid) {
          var approvalsValidate = [];

          _this9.onValidateCbs.forEach(function (cb) {
            approvalsValidate.push(cb(_this9));
          });

          if (!approvalsValidate.includes(false) && nativeValid) {
            form.submittable(true);
            return true;
          }

          form.submittable(false);
          return false;
        });
      });
    }
  }, {
    key: "setButtonText",
    value: function setButtonText(text) {
      var _this10 = this;

      this.onLoad(function (form) {
        return _this10.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').text(text);
      });
      return this;
    }
  }, {
    key: "setButtonDisabled",
    value: function setButtonDisabled(form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr('disabled', true);
    }
  }, {
    key: "setButtonEnable",
    value: function setButtonEnable(form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').removeAttr('disabled');
    }
  }, {
    key: "changeButtonText",
    value: function changeButtonText(text, form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').html(text);
    }
  }, {
    key: "getButtonText",
    value: function getButtonText(form) {
      return this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').html();
    }
  }, {
    key: "setButtonClasses",
    value: function setButtonClasses(classes) {
      var _this11 = this;

      if (classes) {
        this.onLoad(function (form) {
          return _this11.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').removeClass('mktoButton').addClass(classes);
        });
      }

      return this;
    }
  }, {
    key: "setButtonEvents",
    value: function setButtonEvents(events) {
      var _this12 = this;

      if (events) {
        this.onLoad(function (form) {
          Object.entries(events).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            console.log(value);

            _this12.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr(key, value);
          });
        });
      }

      return this;
    }
  }, {
    key: "setButtonTarget",
    value: function setButtonTarget(target) {
      var _this13 = this;

      if (target) {
        this.onLoad(function (form) {
          return _this13.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr('target', target);
        });
      }

      return this;
    }
  }, {
    key: "setValues",
    value: function setValues(values, cbFn) {
      this.onLoad(function (form) {
        form.setValues(values);

        if (typeof cbFn === 'function') {
          cbFn();
        }
      });
      return this;
    }
  }, {
    key: "hasOption",
    value: function hasOption(name, value) {
      var formElem = this.formElem;
      if (!formElem) return false;
      var option = formElem.find("[name=\"".concat(name, "\"] option[value=\"").concat(value, "\"]"));
      return option.length > 0;
    }
  }, {
    key: "updateFieldValue",
    value: function updateFieldValue(field, value) {
      field.val(value);
    }
  }, {
    key: "setValue",
    value: function setValue(name, value, cbFn) {
      var _this14 = this;

      this.onLoad(function (form) {
        try {
          form.setValues(_defineProperty({}, name, value));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Faild to set form field value', {
            field: name,
            value: value
          });
        }

        var formElem = _this14.getFormElem(form);

        var input = $("[name=\"".concat(name, "\"]"), formElem);

        if (input && input.is('select')) {
          var option = input.find("option[value=\"".concat(value, "\"]"));

          if (option.length > 0) {
            option.attr('selected', 'selected');
          }
        }

        if (input && input.is(':visible')) {
          // fire change and blur event to trigger the validations
          input.change();
          input.blur();
        }

        if (typeof cbFn === 'function') {
          cbFn();
        }
      });
      return this;
    }
  }, {
    key: "setThankyouText",
    value: function setThankyouText(html) {
      var _this15 = this;

      if (html) {
        this.onSuccess(function () {
          var formElem = _this15.getFormElem();

          $(formElem).hide();
          var thankyouDiv = "\n          <div id=\"marketo_form_thankyou_".concat(_this15.formId, "\" class=\"marketo-form-thankyou-message\">\n            ").concat(html, "\n          </div>\n        ");
          $(formElem).parent().append(thankyouDiv);
          return false;
        });
      }
    }
  }, {
    key: "setThankyouUrl",
    value: function setThankyouUrl(url) {
      if (url) {
        this.onSuccess(function () {
          window.location.assign(url);
          return false;
        });
      }

      return this;
    }
  }, {
    key: "getFormElem",
    value: function getFormElem(form) {
      if (this.elem) {
        return $(this.elem);
      } else if (form) {
        return form.getFormElem();
      } else if (this.form) {
        return this.form.getFormElem();
      }

      return null;
    }
  }, {
    key: "getField",
    value: function getField(name) {
      var _this16 = this;

      return new Promise(function (resolve) {
        _this16.onLoad(function (form) {
          var formElem = _this16.getFormElem(form);

          var input = $("[name=\"".concat(name, "\"]"), formElem);
          resolve(input);
        });
      });
    }
  }, {
    key: "getValue",
    value: function getValue(name) {
      var _this17 = this;

      return new Promise(function (resolve) {
        _this17.getValues().then(function (vals) {
          resolve(vals[name]);
        });
      });
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _this18 = this;

      return new Promise(function (resolve) {
        _this18.onLoad(function (form) {
          resolve(form.getValues());
        });
      });
    }
  }, {
    key: "setLables",
    value: function setLables(lables) {
      var _this19 = this;

      var keys = Object.keys(lables);
      keys.forEach(function (key) {
        _this19.setLable(key, lables[key]);
      });
      return this;
    }
  }, {
    key: "setAutoLables",
    value: function setAutoLables() {
      var _this20 = this;

      this.onLoad(function (form) {
        var formElem = _this20.getFormElem(form);

        var inputs = $("[name]", formElem);
        var labels = {};
        inputs && inputs.each(function (_, el) {
          if ($(el).prop('nodeName') !== 'SELECT' && $(el).attr('type') !== 'checkbox' && $(el).attr('autoLables') !== 'false') {
            var name = $(el).attr('name');
            var id = $(el).attr('id');
            var placeholder = $(el).attr('placeholder');
            var label = placeholder || name;

            if (id && label) {
              labels[id] = label;
              $(el).attr('placeholder', label === 'FirstName' ? 'First name' : label === 'LastName' ? 'Last name' : label);
            }
          }
        });

        if (labels) {
          _this20.setLables(labels);
        }
      });
      return this;
    }
  }, {
    key: "setLable",
    value: function setLable(id, text) {
      var _this21 = this;

      this.onLoad(function (form) {
        var formElem = _this21.getFormElem(form);

        var label = $("label[for=\"".concat(id, "\"]"), formElem);
        label.text(text);
      });
      return this;
    }
  }, {
    key: "hideField",
    value: function hideField(name, duration) {
      var _this22 = this;

      this.onLoad(function (form) {
        var formElem = _this22.getFormElem(form);

        var fieldRow = $("[name=\"".concat(name, "\"]"), formElem).parents('.mktoFormRow:first');

        if (fieldRow) {
          fieldRow.hide(duration);
        }
      });
      return this;
    }
  }, {
    key: "hasField",
    value: function hasField(name) {
      return this.getField(name).then(function (input) {
        return input.length > 0;
      });
    }
  }, {
    key: "showField",
    value: function showField(name, duration) {
      var _this23 = this;

      this.onLoad(function (form) {
        var formElem = _this23.getFormElem(form);

        var fieldRow = $("[name=\"".concat(name, "\"]"), formElem).parents('.mktoFormRow:first');

        if (fieldRow) {
          fieldRow.show(duration);
        }
      });
      return this;
    }
  }, {
    key: "setErrorMessage",
    value: function setErrorMessage(fieldName, error) {
      var _this24 = this;

      var scrollTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.onLoad(function (form) {
        var formElem = _this24.getFormElem(form);

        var input = $("[name=\"".concat(fieldName, "\"]"), formElem);
        var field = $(input).parents('.mktoFieldWrap:first');

        if (error) {
          input.removeClass('mktoValid');
          input.addClass('mktoInvalid');
          input.siblings('.mktoError').show();
          field.addClass('mktoInvalidField');
        } else {
          input.removeClass('mktoInvalid');
          field.removeClass('mktoInvalidField');
        }

        form.submittable(false);
        form.showErrorMessage(error, input ? MktoForms2.$(input.get(0)) : null); // scroll into invalid input

        if (scrollTo && !_this24.formArgs['doNotScrollOnError']) {
          var top = $(formElem).offset().top;
          var notInModal = !formElem.closest('.modal').length;

          if (notInModal) {
            var header = $('#header');
            top -= header.outerHeight();
            window.scroll({
              top: top,
              left: 0,
              behavior: 'smooth'
            });
          }
        }
      });
      return this;
    }
    /**
     * split the full name to Firstname and LastName
     * @param {string} fullName fullname input value
     * @return {{firstName, lastName}} splitedFullName
     */

  }, {
    key: "splitFullName",
    value: function splitFullName(fullName) {
      /**
       * capitalize all word in given line
       * @param {string} text
       * the line text will be capitalize
       * @example
       * input: "shalom s. tuby"
       * output: "Shalom S. Tuby"
       * @return {string} capitalize all word in given line
       */
      var capitalize = function capitalize(text) {
        return text.toLowerCase().split(' ').map(function (s) {
          return s.charAt(0).toUpperCase() + s.substring(1);
        }).join(' ');
      };

      fullName = fullName.trim();

      if (!fullName) {
        return {};
      } // remove duplicate spaces


      fullName = fullName.replace(/\s{2,}/g, ' ');
      var split = '';

      if (fullName.includes('　')) {
        split = fullName.split('　');
      } else {
        split = fullName.split(' ');
      }

      if (split.length) {
        var firstName = split[0];
        var lastName = split[1] ? split.slice(1).join(' ') : '';
        firstName = capitalize(firstName);
        lastName = capitalize(lastName);
        return {
          firstName: firstName,
          lastName: lastName
        };
      }

      return {};
    }
  }, {
    key: "sendEventOnNoCountry",
    value: function sendEventOnNoCountry() {
      var dataLayerToSend = {
        event: 'GAevent',
        eventCategory: 'country field',
        eventAction: 'view',
        eventLabel: 'request demo form'
      };

      if (!global.dataLayer) {
        global.dataLayer = [];
      }

      global.dataLayer.push(dataLayerToSend);
    }
  }, {
    key: "prePopulatedCountry",
    value: function prePopulatedCountry() {
      var _this25 = this;

      // console.log('prePopulatedCountry for ', this.formId);
      this.hideField('Country').registerEvent('change', 'Country', function (event) {
        var inputElem = $(event.target);
        var val = inputElem.val();

        if (inputElem.is('select')) {
          val = ('option:selected', inputElem).val();
        }

        if (val) {
          _this25.setLable('State', 'State');

          _this25.getField('State').then(function (input) {
            var parent = $(input).parents('.mktoFieldWrap:first');
            var inputType = 'select';
            parent.addClass("inputType_".concat(inputType));
          });
        }
      }); // initial country and state from geo service

      (0, _geoLocationService.getGeoLocationData)().then(function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            state = _ref3.state,
            error = _ref3.error,
            status = _ref3.status,
            country = _ref3.country,
            stateCode = _ref3.stateCode,
            postalcode = _ref3.postalcode;

        // console.log('set GEO location for ', this.formId);
        if (!error && status == _geoLocationService.FINISH_STATUS && country) {
          _this25.onLoad(function () {
            // do not trigger auto Country if the form is in HtmlTemplate mode
            if (_this25.isHtmlTemplate) return; // set the country field from the GEO service

            if (country) {
              if (_this25.hasOption('Country', country)) {
                _this25.setValue('Country', country, function () {
                  _this25.hideField('Country');

                  if (_this25.formElem.find("[name=\"State\"]").length > 0) {
                    if (stateCode || state) {
                      if (_this25.hasOption('State', stateCode)) {
                        _this25.setValue('State', stateCode, function () {
                          return _this25.hideField('State');
                        });
                      } else if (_this25.hasOption('State', state)) {
                        _this25.setValue('State', state, function () {
                          return _this25.hideField('State');
                        });
                      } else {
                        _this25.showField('State');

                        _this25.showField('Country');

                        _this25.sendEventOnNoCountry(); // eslint-disable-next-line no-console


                        console.error('Failed to set State from GeoLocation service');
                      }
                    }
                  }
                });
              } else {
                _this25.sendEventOnNoCountry();

                _this25.showField('Country'); // eslint-disable-next-line no-console


                console.error('Failed to set Country from GeoLocation service');
              }
            } // set the postal_code field from the GEO service


            if (postalcode && postalcode != '0000') {
              _this25.setValue('PostalCode', postalcode);
            }
          });
        } else {
          _this25.sendEventOnNoCountry();

          _this25.showField('Country');

          console.error('Failed to set Country from GeoLocation service');
        }
      }, function (err) {
        _this25.sendEventOnNoCountry(); // eslint-disable-next-line no-console


        console.error('Failed to get country from GeoLocation Service', err);

        _this25.showField('Country');
      });
    }
  }, {
    key: "setHiddenFields",
    value: function setHiddenFields(hiddenFields) {
      var _this26 = this;

      if (hiddenFields) {
        $.each(hiddenFields, function (key, value) {
          var currentKey = key == 'form_type' ? 'formType' : key;

          _this26.setValue(currentKey, value);
        });
      }
    }
  }, {
    key: "setupMarketoForm",
    value: function setupMarketoForm(args) {
      var _this27 = this;

      //add support for error messages translation, get error messages from global var with translations if it exist
      var full_name_error_message = '';
      var email_error = 'Must be valid email. example@yourdomain.com';
      var phone_error = 'Must be a phone number. 503-555-1212';
      var company_error = 'This field is required.';
      var title_error = 'This field is required.';
      var department_error = 'This field is required.';
      var mobilephone_error = 'Must be a phone number. 503-555-1212';
      var firstname_error = 'This field is required.';
      var lastname_error = 'This field is required.';

      if (typeof error_messages !== 'undefined') {
        full_name_error_message = error_messages.full_name_error_message !== undefined ? error_messages.full_name_error_message : '';
        email_error = error_messages.email_error;
        phone_error = error_messages.phone_error;
        company_error = error_messages.company_error;
        title_error = error_messages.title_error;
        department_error = error_messages.department_error;
        mobilephone_error = error_messages.mobilephone_error;
        firstname_error = error_messages.firstname_error;
        lastname_error = error_messages.lastname_error;
      }

      var FullNameErrorMessage = full_name_error_message ? full_name_error_message : (0, _translateService.translate)('marketo_form.full_name_error_message', 'First Name and Last Name required');

      if (!args['no_auto_label']) {
        this.setAutoLables();
      }

      if (args['pre_populated_country']) {
        this.prePopulatedCountry();
      }

      if (args['button_label']) {
        this.setButtonText(args['button_label']);
      }

      if (args['button_class']) {
        this.setButtonClasses(args['button_class']);
      }

      if (args['button_events']) {
        this.setButtonEvents(args['button_events']);
      }

      if (args['thankyou_url']) {
        this.thankyouPageUrl = args['thankyou_url'];
        this.setThankyouUrl(args['thankyou_url']);
      }

      if (args['hidden_fields']) {
        this.setHiddenFields(args['hidden_fields']);
      }

      if (args['validate_fullname']) {
        this.registerEvent('input', 'fullNameTrendemon', function (event) {
          var fullName = event.target.value;

          var _this27$splitFullName = _this27.splitFullName(fullName),
              firstName = _this27$splitFullName.firstName,
              lastName = _this27$splitFullName.lastName;

          _this27.setValue('FirstName', firstName);

          _this27.setValue('LastName', lastName);
        });
        this.onSubmit(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var lastName = $("[name=\"LastName\"]", formElem).val();

          if (!lastName) {
            _form.setErrorMessage('fullNameTrendemon', FullNameErrorMessage);

            return false;
          }

          return true;
        }).onValidate(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var lastName = $("[name=\"LastName\"]", formElem).val();

          if (!lastName) {
            _form.setErrorMessage('fullNameTrendemon', FullNameErrorMessage);

            return false;
          }

          return true;
        }).registerEvent('blur', 'fullNameTrendemon',
        /*#__PURE__*/
        function () {
          var _ref4 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(event) {
            var inputElem, parent, lastNameElem, lastName;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this27.getField('fullNameTrendemon');

                  case 2:
                    inputElem = _context2.sent;
                    parent = inputElem.parents('.mktoFieldWrap:first');
                    _context2.next = 6;
                    return _this27.getField('LastName');

                  case 6:
                    lastNameElem = _context2.sent;
                    lastName = lastNameElem.val();

                    if (!lastName) {
                      setTimeout(function () {
                        inputElem.addClass('mktoInvalid');
                        inputElem.removeClass('mktoValid');
                        parent.addClass('mktoInvalidField');

                        _this27.setErrorMessage('fullNameTrendemon', FullNameErrorMessage, false);
                      }, 0);
                    } else {
                      setTimeout(function () {
                        inputElem.removeClass('mktoInvalid');
                        parent.removeClass('mktoInvalidField');
                      }, 0);
                    }

                  case 9:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }()).registerEvent('focusin', 'fullNameTrendemon',
        /*#__PURE__*/
        function () {
          var _ref5 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee3(event) {
            var inputElem, parent;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this27.getField('fullNameTrendemon');

                  case 2:
                    inputElem = _context3.sent;
                    parent = inputElem.parents('.mktoFieldWrap:first');
                    inputElem.removeClass('mktoInvalid');
                    parent.removeClass('mktoInvalidField'); //support error messages translation

                    if (typeof error_messages !== 'undefined') {
                      _this27.onLoad(function (form) {
                        form.showErrorMessage(FullNameErrorMessage, inputElem ? MktoForms2.$(inputElem.get(0)) : null);
                      });
                    }

                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x2) {
            return _ref5.apply(this, arguments);
          };
        }());
      }

      if (args['validate_private_email_domain']) {
        this.onSubmit(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var privateEmail = $("[name=\"Email\"]", formElem).val().toLowerCase();
          var emailDomain = privateEmail.split('@');

          if ($.inArray(emailDomain[1], emails) !== -1) {
            _form.setErrorMessage('Email', args['email_domain_error']);

            return false;
          }

          return true;
        }).onValidate(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var privateEmail = $("[name=\"Email\"]", formElem).val().toLowerCase();
          var emailDomain = privateEmail.split('@');

          if ($.inArray(emailDomain[1], emails) !== -1) {
            _form.setErrorMessage('Email', args['email_domain_error']);

            return false;
          }

          return true;
        }).registerEvent('blur', 'Email',
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee4() {
          var inputElem, email, emailDomain;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this27.getField('Email');

                case 2:
                  inputElem = _context4.sent;
                  email = inputElem.val().toLowerCase();
                  emailDomain = email.split('@');

                  if ($.inArray(emailDomain[1], emails) !== -1) {
                    setTimeout(function () {
                      inputElem.addClass('mktoInvalid');
                      inputElem.removeClass('mktoValid');

                      _this27.setErrorMessage('Email', args['email_domain_error'], false);
                    }, 0);
                  } else {
                    setTimeout(function () {
                      inputElem.removeClass('mktoInvalid');
                    }, 0);
                  }

                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))).registerEvent('focusin', 'Email',
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee5() {
          var inputElem;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this27.getField('Email');

                case 2:
                  inputElem = _context5.sent;
                  inputElem.removeClass('mktoInvalid');

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        })));
      }

      var validateNotEmpty = function validateNotEmpty(str) {
        return str.length;
      };

      var validateEmail = function validateEmail(str) {
        var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        return re.test(String(str).toLowerCase());
      };

      var validateNum = function validateNum(str) {
        return validateNotEmpty(str) && /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/.test(str);
      };

      var getValidatorByName = function getValidatorByName(name) {
        var meta = {
          Email: validateEmail,
          Phone: validateNum,
          Company: validateNotEmpty,
          Title: validateNotEmpty,
          MobilePhone: validateNum
        };
        return meta[name] || validateNotEmpty;
      };

      var inputsOnBlur = function inputsOnBlur(e, errorMessage) {
        var inputElem = jQuery(e.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        var val = inputElem.val();
        var validatorFn = getValidatorByName(inputElem.attr('name'));

        if (!validatorFn(val)) {
          setTimeout(function () {
            inputElem.addClass('mktoInvalid');
            inputElem.removeClass('mktoValid');
            parent.addClass('mktoInvalidField');

            _this27.setErrorMessage(inputElem.attr('name'), errorMessage, false);
          }, 0);
        } else {
          setTimeout(function () {
            inputElem.removeClass('mktoInvalid');
            parent.removeClass('mktoInvalidField');
          }, 0);
        }
      };

      var inputsOnFoucsIn =
      /*#__PURE__*/
      function () {
        var _ref8 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee6(e, errorMessage) {
          var inputElem, parent;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  inputElem = jQuery(e.target);
                  parent = inputElem.parents('.mktoFieldWrap:first');
                  inputElem.removeClass('mktoInvalid');
                  parent.removeClass('mktoInvalidField'); //support error messages translation

                  if (typeof error_messages !== 'undefined') {
                    _this27.onLoad(function (form) {
                      form.showErrorMessage(errorMessage, inputElem ? MktoForms2.$(inputElem.get(0)) : null);
                    });
                  }

                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function inputsOnFoucsIn(_x3, _x4) {
          return _ref8.apply(this, arguments);
        };
      }();

      var inputsOnSubmit = function inputsOnSubmit(name, form, errorMessage) {
        if (typeof error_messages !== 'undefined') {
          var input = $("[name=\"".concat(name, "\"]"), form);
          var parent = input.parent();

          if (parent.hasClass('mktoFieldTouched') && parent.hasClass('mktoInvalidField')) {
            _this27.setErrorMessage(name, errorMessage, false);
          }
        }

        return true;
      };

      [['Email', args['email_invalid_error'] !== '' ? args['email_invalid_error'] : email_error], ['Phone', phone_error], ['Company', company_error], ['Title', title_error], ['Department', department_error], ['MobilePhone', mobilephone_error], ['FirstName', firstname_error], ['LastName', lastname_error]].forEach(function (field) {
        var name = field[0];
        var msg = field[1];

        _this27.registerEvent('blur', name, function (e) {
          inputsOnBlur(e, msg);
        });

        _this27.registerEvent('focusin', name, function (e) {
          inputsOnFoucsIn(e, msg);
        });

        _this27.onLoad(function (form) {
          var formElem = _this27.getFormElem(form);

          formElem.on('submit', {
            name: name,
            formElem: formElem,
            msg: msg
          }, function (e) {
            inputsOnSubmit(e.data.name, e.data.formElem, e.data.msg);
          });
        });
      }); // lets to know if submit was triggered by 'ENTER'

      var onKeyPress = function onKeyPress(e) {
        var key = e.key;

        if (key.toUpperCase().trim() === 'ENTER') {
          _this27.keyEnterPressed = true;
          clearTimeout(_this27.pressOnEnterTimer);
          _this27.pressOnEnterTimer = setTimeout(function () {
            _this27.keyEnterPressed = false;
          }, 1000);
        }
      }; // lets to know if submit was triggered by click


      var clickOnSubmitFn = function clickOnSubmitFn(e) {
        _this27.submitBtnClicked = true;
        clearTimeout(_this27.clickOnSubmitTimer);
        _this27.clickOnSubmitTimer = setTimeout(function () {
          _this27.submitBtnClicked = false;
        }, 1000);
      };

      this.onLoad(function (form) {
        var formElem = _this27.getFormElem(form);

        if (formElem.length) {
          var submitBtn = formElem.find('button[type="submit"]');
          submitBtn.on('click', clickOnSubmitFn);
        }

        document.addEventListener('keypress', onKeyPress);
      }); // remove error message for empty focused input

      this.onValidate(function (_form) {
        setTimeout(function (_form) {
          var $form = _this27.getFormElem(_form);

          var fullNameElem = $form.find('[name="fullNameTrendemon"]');
          var focusedElem = $(document.activeElement);

          var showEmptyMsg = function showEmptyMsg(name) {
            return _this27.setErrorMessage(name, '  ', false);
          }; // show empty error message when focused field is empty


          if (focusedElem.length && _this27.keyEnterPressed) {
            var focusedElemTagName = focusedElem[0].tagName.toUpperCase();
            var val = focusedElem.val();
            var valIsEmty = !val.length;

            if (valIsEmty && (focusedElemTagName === 'INPUT' || focusedElemTagName === 'SELECT' || focusedElemTagName === 'TEXTAREA')) {
              var name = focusedElem.attr('name');

              if (args['validate_fullname']) {
                if (!fullNameElem.val()) {
                  showEmptyMsg(name);
                }
              } else {
                showEmptyMsg(name);
              }

              return;
            }
          } // set error state if submit is clicked and field is empty


          if (args['validate_fullname'] && _this27.submitBtnClicked && !_this27.keyEnterPressed) {
            var lastNameElem = $form.find('[name="LastName"]');

            if (!fullNameElem.val() || !lastNameElem.val()) {
              var parent = fullNameElem.parents('.mktoFieldWrap:first');
              fullNameElem.addClass('mktoInvalid');
              fullNameElem.removeClass('mktoValid');
              parent.addClass('mktoInvalidField'); // className "mktoFieldTouched" needed for red border on the input

              parent.addClass('mktoFieldTouched');

              _this27.setErrorMessage('fullNameTrendemon', FullNameErrorMessage, false);
            }
          }

          _this27.submitBtnClicked = false;
          _this27.keyEnterPressed = false;
        }, 30, _form);
      });
      this.onLoad(function (form) {
        // set the input type on mktoFieldWrap element
        var formElem = _this27.getFormElem(form);

        if (typeof field_labels !== 'undefined') {
          $('label', formElem).each(function (i, elem) {
            var label = $(elem);

            if (typeof field_labels[label.text()] !== 'undefined') {
              label.text(field_labels[label.text()]);
            }
          });
        }

        $('input,textarea', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = $(elem).attr('type');
          parent.addClass("inputType_".concat(inputType));

          if (typeof field_labels !== 'undefined') {
            var input = elem;

            if (typeof field_labels[input.getAttribute('placeholder')] !== 'undefined') {
              input.setAttribute('placeholder', field_labels[input.getAttribute('placeholder')]);
            }
          }
        });
        $('textarea', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = 'textarea';
          parent.addClass("inputType_".concat(inputType));
        });
        $('select', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = 'select';
          parent.addClass("inputType_".concat(inputType));

          if ($(elem).attr('autoLables') !== 'false') {
            parent.find('.mktoLabel').text(parent.find('option:first').text());
          }

          parent.find('option:first').text('Please choose');
        });
        /* Potential use for translating buttons, however a brute (overall) solution was found for Downloads in /themes/impv-resources/loop-templates/content-gated-ungated.php
        $('button', formElem).each((i, elem) => {
          const button_text = $(elem).html();
          if (typeof field_labels !== 'undefined') {
            if (field_labels[button_text] !== 'undefined') {
              $(elem).html( field_labels[button_text] );
            }
          }
        }); */
      }) // populate the input validation and focuse state to the parent div
      .registerEvent('focus blur', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        /**
         * inputElem.is(document.activeElement) is workaround to support focus on safari
         */

        if (inputElem.is(':focus') || inputElem.is(document.activeElement)) {
          parent.addClass('mktoFieldFocus');
        } else {
          parent.removeClass('mktoFieldFocus');
        }

        setTimeout(function () {
          if (inputElem.hasClass('mktoInvalid')) {
            parent.addClass('mktoInvalidField');
          } else {
            parent.removeClass('mktoInvalidField');
          }
        }, 0);
      }) // populate the input validation to the parent div
      .registerEvent('focusin keyup', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');

        if (inputElem.hasClass('mktoInvalid')) {
          parent.addClass('mktoInvalidField');
        } else {
          parent.removeClass('mktoInvalidField');
        }
      }).registerEvent('focusout', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first'); // for the first time the imput was touched

        parent.addClass('mktoFieldTouched');
      }).registerEvent('change', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        var val = inputElem.val();

        if (inputElem.is('select')) {
          val = ('option:selected', inputElem).val();
        }

        if (val) {
          parent.addClass('mktoFieldFill');
        } else {
          parent.removeClass('mktoFieldFill');
        }
      });
    }
  }, {
    key: "setHtmlTemplate",
    value: function setHtmlTemplate() {
      $(this.formElem).addClass('html-template');
    }
  }], [{
    key: "register",
    value: function register() {
      // find forms
      var formNodes = _toConsumableArray(document.querySelectorAll('form.marketo-form')); // create list with unique ids


      this.formIds = formNodes.reduce(function (list, form) {
        var id = form.dataset.formId;

        if (id && list.indexOf(id) === -1) {
          list.push(id);
        }

        return list;
      }, []); // init marketo forms for each ID

      this.formIds.forEach(function (formId) {
        // find forms with current id
        var idForms = _toConsumableArray(document.querySelectorAll("form.marketo-form[data-form-id=\"".concat(formId, "\"]"))); // next form with the same ID will be loaded on callback that takes MktoForms2.loadForm function


        (function loadFormHandler(idForms) {
          if (idForms.length) {
            var formEl = idForms.shift();
            var nextFormFn = loadFormHandler.bind(null, _toConsumableArray(idForms));
            var index = formNodes.indexOf(formEl);
            registerForm(index, formEl, nextFormFn);
          }
        })(idForms);
      });

      function registerForm(idx, e, runNextFormFn) {
        var formArgs = {};
        $(e).data('index', idx);

        try {
          var formArgsKey = $(e).data('form-args');

          if (formArgsKey && formArgsKey in window) {
            formArgs = window[formArgsKey];
          }
        } catch (err) {
          console.error('Faild to parse form args from element data', err);
        }

        var getFormId = function getFormId(e) {
          if (formArgs) {
            if (formArgs.form_id) {
              return formArgs.form_id;
            }
          }

          var formId = $(e).data('form-id');

          if (!formId) {
            var elId = $(e).attr('id');

            if (elId) {
              var s = elId.split('_');

              if (s.length > 1) {
                formId = s.pop();
              }
            }
          }

          return formId;
        };

        var formId = getFormId(e);
        console.info('register marketo form', formId);

        if (!formArgs.uuid) {
          formArgs.uuid = parseInt(Math.random() * 10000);
        }

        if (formId) {
          var uuid = formArgs.uuid;
          $(e).attr('data-uuid', uuid); // if someone waiting to this form - fire event

          var instance = new MarketoForm(formId, formArgs, e, runNextFormFn);

          if (typeof marketoForms[formId] === 'function') {
            var cb = marketoForms[formId];
            marketoForms[uuid] = instance;
            cb(instance);
          } else {
            marketoForms[uuid] = instance;
          }
        }
      }
    }
  }, {
    key: "findById",
    value: function findById(formId) {
      return new Promise(function (resolve) {
        var found = Object.values(marketoForms).filter(function (m) {
          return m.formId == formId;
        });

        if (found && found.length > 0) {
          resolve(found[0]);
        } else {
          marketoForms[formId] = resolve;
        }
      });
    }
  }]);

  return MarketoForm;
}();

exports["default"] = MarketoForm;

var createForm = function createForm(formId) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var elem = arguments.length > 2 ? arguments[2] : undefined;
  return new MarketoForm(formId, args, elem);
};

exports.createForm = createForm;

var findById = function findById(formId) {
  return MarketoForm.findById(formId);
};

exports.findById = findById;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"impv/src/js/services/geo-location-service":5,"impv/src/js/services/translate-service":8}],2:[function(require,module,exports){
(function (global){
"use strict";

var _marketoForm = require("impv/src/js/components/marketo-form");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

document.addEventListener('form2init', marketoFormActions);

function marketoFormActions() {
  global.openModal = function (id, virtualpageurl, virtualtitle) {
    var optionalargs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var modalEl = $('#' + id);
    if (!modalEl.length) return;
    modalEl.modal('show');

    if (!global.dataLayer) {
      global.dataLayer = [];
    }

    if ('dataLayer' in window && virtualpageurl && virtualtitle) {
      window.dataLayer.push({
        event: 'VirtualPageview',
        virtualPageURL: virtualpageurl,
        virtualPageTitle: virtualtitle
      });
    }

    if ('hj' in window) {
      //Hotjar Virtual Page View trigger.
      hj('vpv', 'showmodal' + id);
    }

    if (optionalargs) {
      if (optionalargs.formFieldToUpdate && optionalargs.formFieldValuetoupdate) {
        $(
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee() {
          var titleEl, formId, form;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (optionalargs.modalElementToUpdate) {
                    titleEl = modalEl.find('.modal-element-to-update');

                    if (titleEl.length) {
                      titleEl.html(optionalargs.modalElementToUpdate);
                    }
                  }

                  formId = $('#' + id + ' .modalformselements').val();
                  _context.next = 4;
                  return (0, _marketoForm.findById)(formId);

                case 4:
                  form = _context.sent;
                  form.updateFieldValue(optionalargs.formFieldToUpdate, optionalargs.formFieldValuetoupdate);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
      }
    }
  };
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"impv/src/js/components/marketo-form":1}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var GOOGLE_GEOCODE_CLIENT_API_KEY = window.pageGlobalData.GOOGLE_GEOCODE_CLIENT_API_KEY;
var _default = {
  API_KEY: GOOGLE_GEOCODE_CLIENT_API_KEY,
  BASE_URL: 'https://www.googleapis.com/geolocation/v1/geolocate'
};
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

require("./components/modal-component");

},{"./components/modal-component":2}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ERROR_STATUS = exports.FINISH_STATUS = exports.IN_PROGRESS_STATUS = exports.INITIAL_STATUS = exports.getGeoLocationData = exports.GeoLocationService = void 0;

var _googleGeolocationApi = _interopRequireDefault(require("../services/google-geolocation-api"));

var _sessionStorageService = _interopRequireDefault(require("./session-storage-service"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// create a uniqe symble
var singleton = Symbol();
/**
 *
 * This class is service to user data (country etc.)
 *
 * @example
 * import {getGeoLocationData} from './services/geo-location-service'
 * getGeoLocationData().then((data) => {
 *  // do something...
 * })
 *
 */

var GeoLocationService =
/*#__PURE__*/
function () {
  _createClass(GeoLocationService, null, [{
    key: "instance",

    /** process status */

    /** const keys */

    /**
     * @default GEO_LOCATION_DATA
     */

    /**
     * @default GEO_LOCTION_FINISHED
     */
    // return a singleton instance
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new GeoLocationService();
      }

      return this[singleton];
    }
  }]);

  function GeoLocationService() {
    _classCallCheck(this, GeoLocationService);

    this.sessionStorageService = _sessionStorageService["default"];
    this.googleGeolocationAPI = _googleGeolocationApi["default"];
    this.baseURL = '/wp-json/geoLocationData/v1/geo';
    this.state = {
      status: GeoLocationService.INITIAL
    };
    this.init();
  }

  _createClass(GeoLocationService, [{
    key: "setState",
    value: function setState(newState) {
      var state = this.state;
      this.state = _objectSpread({}, state, {}, newState);

      if (this.state.status == GeoLocationService.ERROR) {
        console.error('GeoLocationService: An error occurred while trying to get user country', this.state.error);
        this.fireEvent(this.state);
      } else if (this.state.status == GeoLocationService.FINISH) {
        var _this$state = this.state,
            country = _this$state.country,
            countryCode = _this$state.countryCode,
            _state = _this$state.state,
            stateCode = _this$state.stateCode,
            city = _this$state.city,
            postalcode = _this$state.postalcode;
        this.sessionStorageService.setItem(GeoLocationService.CACHE_KEY, {
          country: country,
          countryCode: countryCode,
          state: _state,
          stateCode: stateCode,
          city: city,
          postalcode: postalcode
        });
        this.onFinish();
      }
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.state;
    }
    /**
     *
     * @description register the user data loaded
     * this event will fire after all the process finished
     *
     * @example import {getGeoLocationData} from './services/geo-location-service';
     *  getGeoLocationData.then((data) => console.log('user data', data));
     *  or:
     *  $(document).on(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, (data) => console.log('user data', data));
     * @return {Promise<object>}
     * return Promise object
     */

  }, {
    key: "fireEvent",
    value: function fireEvent(data) {
      $(document).trigger(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, data);
    }
  }, {
    key: "onFinish",
    value: function onFinish() {
      this.fireEvent(this.state);
    }
    /**
     *
     * get the user data from incapsula service
     *
     * @return {Promise<{country:string,countryCode:string,data:string,stateCode:string,city:string,postalcode:string}>}
     * return promise with result object
     */

  }, {
    key: "getUserData",
    value: function getUserData() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        // console.log(`GET ${this.baseURL}`);
        $.get(_this.baseURL).then(function (res) {
          if (res && res.success && res.result) {
            var data = res.result;

            if (data.country_name) {
              return resolve({
                country: data.country_name,
                countryCode: data.country_code,
                state: data.state_name,
                stateCode: data.state_code,
                city: data.city_name,
                postalcode: data.postal_code
              });
            }
          }

          return reject('No data recived');
        }, function (err) {
          reject(err);
        });
      });
    }
    /**
     * getUserDataUsingLocation:
     *
     * get the user data from google geocodding service
     *
     * @param {{lat: string, lan: string}} latlng
     *  lan and lat location
     *
     * @return {Promise<{country:string,countryCode:string,data:string,stateCode:string,city:string,postalcode:string}>}
     * return promise with result object
     */

  }, {
    key: "getUserDataUsingLocation",
    value: function getUserDataUsingLocation(latlng) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        // console.log(`POST ${this.baseURL}`, latlng);
        $.post(_this2.baseURL, latlng).then(function (res) {
          if (res && res.success && res.result) {
            var data = res.result;

            if (data.country_name) {
              return resolve({
                country: data.country_name,
                countryCode: data.country_code,
                state: data.state_name,
                stateCode: data.state_code,
                city: data.city_name,
                postalcode: data.postal_code
              });
            } else {
              return reject('No data provided, no country name was return');
            }
          } else {
            return reject('No data provided, failed');
          }
        }, function (err) {
          reject('request to server failed ' + err);
        });
      });
    }
  }, {
    key: "getLatLan",
    value: function getLatLan() {
      return this.googleGeolocationAPI.getLatLan();
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      this.setState({
        status: GeoLocationService.IN_PROGRESS
      }); // if the data already in cache return from cache

      var data = this.sessionStorageService.getItem(GeoLocationService.CACHE_KEY); // if the data found in cache return this data;

      if (data) {
        this.setState(_objectSpread({
          status: GeoLocationService.FINISH
        }, data));
        return;
      } // else, start request the user data from the server
      // tring to get the user country name from incapsula service


      this.getUserData().then(function (data) {
        /**
         * if got the data finish the process and save the data to state and fire finish event
         */
        _this3.setState(_objectSpread({
          status: GeoLocationService.FINISH
        }, data));
      }, // else; try another way:
      function (err) {
        // get the lan and lat location from google service
        _this3.getLatLan().then(function (latlng) {
          // parse the lan lat location to country name unsing google geocoding service
          _this3.getUserDataUsingLocation(latlng).then(function (data) {
            // if got the data finish the process and save the data to state and fire finish event
            _this3.setState(_objectSpread({
              status: GeoLocationService.FINISH
            }, data));
          }, function (err) {
            // console.error('Faild to get user data with latlan', err);
            _this3.setState({
              status: GeoLocationService.ERROR,
              error: err
            });
          });
        }, function (err) {
          // console.error('Faild to get user data', err);
          _this3.setState({
            status: GeoLocationService.ERROR,
            error: err
          });
        });
      });
    }
  }], [{
    key: "getGeoLocationData",
    value: function getGeoLocationData() {
      var instance = GeoLocationService.instance;
      return new Promise(function (resolve, reject) {
        if (instance.getState().status == GeoLocationService.FINISH) {
          resolve(instance.getState());
        } else {
          var cbFn = function cbFn(_, data) {
            reject(data.error);
            $(document).off(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, cbFn);
          };

          reject('No country data found');
          $(document).on(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, cbFn);
        }
      });
    }
  }]);

  return GeoLocationService;
}();

exports.GeoLocationService = GeoLocationService;

_defineProperty(GeoLocationService, "INITIAL", 'INITIAL');

_defineProperty(GeoLocationService, "IN_PROGRESS", 'IN_PROGRESS');

_defineProperty(GeoLocationService, "FINISH", 'FINISH');

_defineProperty(GeoLocationService, "ERROR", 'ERROR');

_defineProperty(GeoLocationService, "CACHE_KEY", 'GEO_LOCATION_DATA');

_defineProperty(GeoLocationService, "GEO_LOCTION_FINISHED_EVENT", 'GEO_LOCTION_FINISHED');

var getGeoLocationData = GeoLocationService.getGeoLocationData;
exports.getGeoLocationData = getGeoLocationData;
var INITIAL_STATUS = GeoLocationService.INITIAL;
exports.INITIAL_STATUS = INITIAL_STATUS;
var IN_PROGRESS_STATUS = GeoLocationService.IN_PROGRESS;
exports.IN_PROGRESS_STATUS = IN_PROGRESS_STATUS;
var FINISH_STATUS = GeoLocationService.FINISH;
exports.FINISH_STATUS = FINISH_STATUS;
var ERROR_STATUS = GeoLocationService.ERROR;
exports.ERROR_STATUS = ERROR_STATUS;
var _default = GeoLocationService.instance;
exports["default"] = _default;

},{"../services/google-geolocation-api":6,"./session-storage-service":7}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _googleApi = _interopRequireDefault(require("../config/google-api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var API_KEY = _googleApi["default"].API_KEY,
    BASE_URL = _googleApi["default"].BASE_URL; // create a uniqe symble

var singleton = Symbol();

var GoogleGeolocationAPI =
/*#__PURE__*/
function () {
  function GoogleGeolocationAPI() {
    _classCallCheck(this, GoogleGeolocationAPI);
  }

  _createClass(GoogleGeolocationAPI, [{
    key: "createRequest",
    value: function createRequest(url) {
      return new Promise(function (resolve, reject) {
        $.post(url).done(resolve).fail(reject);
      });
    } // return a promise

  }, {
    key: "getLatLan",
    value: function getLatLan() {
      var url = "".concat(BASE_URL, "?key=").concat(API_KEY);
      return this.createRequest(url).then(function (res) {
        var _res$location = res.location,
            lat = _res$location.lat,
            lng = _res$location.lng; // convert lng to lan

        return {
          lat: lat,
          lan: lng
        };
      })["catch"](function (err) {
        return console.error('Faild to request lan - lat from google api');
      });
    }
  }], [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new GoogleGeolocationAPI();
      }

      return this[singleton];
    }
  }]);

  return GoogleGeolocationAPI;
}();

var _default = GoogleGeolocationAPI.instance;
exports["default"] = _default;

},{"../config/google-api":3}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isBrowserSupportSessionStorage = function isBrowserSupportSessionStorage() {
  return 'sessionStorage' in window;
}; // create a uniqe symble


var singleton = Symbol();

var SessionStorageService =
/*#__PURE__*/
function () {
  _createClass(SessionStorageService, null, [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new SessionStorageService();
      }

      return this[singleton];
    }
  }]);

  function SessionStorageService() {
    _classCallCheck(this, SessionStorageService);

    this.isSupported = isBrowserSupportSessionStorage();

    if (this.isSupported) {
      this.sessionStorage = window.sessionStorage;
    }
  }
  /**
   * load the value from sessionStorage
   * the value will parse to object using JSON.parse
   * @param {string} key
   * @param {object} value
   * @return {object}
   * TODO: implement expired date option, should return null if date is expired
   */


  _createClass(SessionStorageService, [{
    key: "getItem",
    value: function getItem(key) {
      try {
        if (!this.isSupported) return null;
        var value = this.sessionStorage.getItem(key);

        if (value) {
          return JSON.parse(value);
        } else {
          return null;
        }
      } catch (error) {
        console.log('An error occurred in SessionStorageService:getItem', error);
      }
    }
    /**
     * save the value in sessionStorage
     * the value will parse to string using JSON.stringify
     * @param {string} key
     * @param {object} value
     * @return {object}
     * TODO: implement expired date option,
     * should save the expired date as new item
     */

  }, {
    key: "setItem",
    value: function setItem(key, value) {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.log('An error occurred in SessionStorageService:setItem', error);
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.removeItem(key);
      } catch (error) {
        console.log('An error occurred in SessionStorageService:removeItem', error);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.clear();
      } catch (error) {
        console.log('An error occurred in SessionStorageService:clear', error);
      }
    }
  }, {
    key: "generateKey",
    value: function generateKey(object) {
      var _this = this;

      if (!object) {
        return '';
      } else if (Array.isArray(object)) {
        return object.map(function (i) {
          return _this.generateKey(i);
        }).join('_');
      } else if (_typeof(object) === 'object') {
        return Object.keys(object).map(function (key) {
          return key + '_' + _this.generateKey(object[key]);
        }).join('_');
      }

      return object;
    }
  }]);

  return SessionStorageService;
}();

var _default = SessionStorageService.instance;
exports["default"] = _default;

},{}],8:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function byString(o, s) {
  try {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties

    s = s.replace(/^\./, ''); // strip a leading dot

    var a = s.split('.');

    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];

      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }

    return o;
  } catch (error) {
    return undefined;
  }
}

var TranslateService =
/*#__PURE__*/
function () {
  _createClass(TranslateService, null, [{
    key: "instance",
    get: function get() {
      if (!global.TranslateService) {
        global.TranslateService = new TranslateService();
      }

      return global.TranslateService;
    }
  }]);

  function TranslateService() {
    _classCallCheck(this, TranslateService);

    this.translate = this.translate.bind(this);
  }

  _createClass(TranslateService, [{
    key: "getTranlateMap",
    value: function getTranlateMap() {
      if (!this.tranlateMap) {
        this.tranlateMap = window.TranslateMap;
      }

      return this.tranlateMap;
    }
    /**
     * translate and field from Translate Option page on WP admin
     *
     * @param {string} field the field name (i.e. 'marketo_form.full_name_error_message')
     * @param {string | any} defaultValue if value is not exsist return this default value
     * @return {string} the translated text (or default value)
     *
     * @example
     *    import { translate } from 'impv/src/js/services/translate-service';
     *    translate('section.field_name', 'some_default_value_str');
     * 
     */

  }, {
    key: "translate",
    value: function translate() {
      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tranlateMap = this.getTranlateMap();

      if (!field || !tranlateMap) {
        return defaultValue;
      } else {
        return byString(tranlateMap, field) || defaultValue;
      }
    }
  }]);

  return TranslateService;
}();

var _default = TranslateService.instance;
exports["default"] = _default;
var translate = TranslateService.instance.translate;
exports.translate = translate;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[4]);
